import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { IApiPagination } from "../../../interfaces/IPagination";
import {
  GetProductsFilterResponse,
  ProductInterface,
  TProductFilter,
} from "../../../interfaces/productInterface";
import axiosTeethTab from "../../../services/apiCall";

type ProductApiInterface = {
  getProducts: () => Promise<ApiResponse<ProductInterface[]>>;
  getProductsFilter: (
    filter: TProductFilter,
    pagination?: IApiPagination,
  ) => Promise<ApiResponse<GetProductsFilterResponse>>;
  getProductById: (
    productId?: string,
  ) => Promise<ApiResponse<ProductInterface>>;
  saveProduct: (
    product: ProductInterface,
  ) => Promise<ApiResponse<ProductInterface>>;
  getProductsByCategories: (
    categories?: string[],
  ) => Promise<ApiResponse<ProductInterface[]>>;
  enable: (id: string) => Promise<ApiResponse<ProductInterface>>;
  disable: (id: string) => Promise<ApiResponse<ProductInterface>>;
};

const productApi: ProductApiInterface = {
  getProducts: async () => {
    const endpoint = "products";
    return await axiosTeethTab.get<ProductInterface[]>(endpoint);
  },
  getProductsFilter: async (filter, pagination) => {
    const endpoint = "products/filter";
    return await axiosTeethTab.get(endpoint, {
      params: { filter, pagination },
    });
  },
  getProductById: async (productId) => {
    const endpoint = `products/${productId}`;
    return await axiosTeethTab.get<ProductInterface>(endpoint);
  },
  saveProduct: async (product) => {
    const endpoint = product._id ? `products/${product._id}` : "products";
    return await axiosTeethTab.post<ProductInterface>(endpoint, product);
  },
  getProductsByCategories: async (categories = []) => {
    const endpoint = "products/by-categories";
    return await axiosTeethTab.get<ProductInterface[]>(endpoint, {
      params: { categories: JSON.stringify(categories) },
    });
  },
  enable: async (id: string) => {
    return await axiosTeethTab.patch<ProductInterface>(`products/${id}/enable`);
  },
  disable: async (id: string) => {
    return await axiosTeethTab.patch<ProductInterface>(`products/${id}/disable`);
  },
};

export default productApi;
